export default "__VITE_ASSET__0090d3e0__"